import { faPlus } from '@fortawesome/free-solid-svg-icons';
import TableHeader from './TableHeader';
import TableRow from './TableRow';
import Button from '../../Common/Button/Button';
import { formatTableName } from '../../Utils/tableHelpers';
import './TableView.css';

/**
 * Table Display Component
 * Simple read-only view for template tables with row actions
 * Note: Custom tables now use TableBuilder for all editing
 */
const TableDisplay = ({ 
  table, 
  rows = [], 
  onAddRow, 
  onEditRow, 
  onDeleteRow,
  permissions = {}
}) => {
  const renderTableStats = () => {
    const totalRows = rows.length;
    
    return (
      <div className="table-stats">
        <div className="table-stat">
          <div className="table-stat-value">{totalRows}</div>
          <div className="table-stat-label">Total Rows</div>
        </div>
      </div>
    );
  };

  const renderEmptyState = () => (
    <div className="table-empty">
      <h4>No data available</h4>
      <p>This table doesn't have any rows yet.</p>
      {permissions.canCreate && (
        <Button
          variant="primary"
          icon={faPlus}
          onClick={onAddRow}
        >
          Add First Row
        </Button>
      )}
    </div>
  );

  return (
    <div className="table-view-container">
      <div className="table-view-header">
        <h3 className="table-view-title">
          View "{formatTableName(table.table_name)}"
        </h3>
        {permissions.canCreate && (
          <div className="table-view-actions">
            <Button
              variant="primary"
              icon={faPlus}
              onClick={onAddRow}
              disabled={permissions.isRestricted}
            >
              Add Row
            </Button>
          </div>
        )}
      </div>

      {renderTableStats()}

      <div className="table-display">
        {rows.length === 0 ? (
          renderEmptyState()
        ) : (
          <div className="table-scrollable">
            <table className="data-table">
              <TableHeader 
                table={table} 
                permissions={permissions}
              />
              <tbody>
                {rows.map((row, rowIndex) => (
                  <TableRow
                    key={row.id || rowIndex}
                    row={row}
                    rowIndex={rowIndex}
                    table={table}
                    onEdit={onEditRow}
                    onDelete={onDeleteRow}
                    permissions={permissions}
                  />
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default TableDisplay;
